import Vue from 'vue'
import Router from 'vue-router'

import phone from '../pages/phone'
import index from '../pages/index'
import my from '../pages/my'
import userinfo from '../pages/userinfo'
import order from '../pages/order'
import mycar from '../pages/mycar'
import addcar from '../pages/addcar'
import msg from '../pages/msg'
import opinion from '../pages/opinion'
import carinfo from '../pages/carinfo'
import pay from '../pages/pay'
import query from '../pages/query'
import success from '../pages/success'
import deft from '../pages/deft'
import advice from '../pages/advice'
import invoice from '../pages/invoice'
import personal from '../pages/personal'
import detail from '../pages/detail'
import problem from '../pages/problem'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: '首页'
      }
    }, {
      path: '/my',
      name: 'my',
      component: my,
      meta: {
        title: '个人中心'
      }
    }, {
      path: '/userinfo',
      name: 'userinfo',
      component: userinfo,
      meta: {
        title: '个人信息'
      }
    }, {
      path: '/order',
      name: 'order',
      component: order,
      meta: {
        title: '订单查询'
      }
    }, {
      path: '/mycar',
      name: 'mycar',
      component: mycar,
      meta: {
        title: '我的车辆'
      }
    }, {
      path: '/addcar',
      name: 'addcar',
      component: addcar,
      meta: {
        title: '添加车辆'
      }
    }, {
      path: '/msg',
      name: 'msg',
      component: msg,
      meta: {
        title: '消息'
      }
    },  {
      path: '/opinion',
      name: 'opinion',
      component: opinion,
      meta: {
        title: '意见反馈'
      }
    } , {
      path: '/carinfo/:id',
      name: 'carinfo',
      component: carinfo,
      // props: true,
      meta: {
        title: '停车场信息'
      }
    }, {
      path: '/pay',
      name: 'pay',
      component: pay,
      meta: {
        title: '支付信息'
      }  
    }, {
      path: '/query',
      name: 'query',
      component: query,
      meta: {
        title: '查询中'
      }  
    }, {
      path: '/success',
      name: 'success',
      component: success,
      meta: {
        title: '支付成功'
      } 
    }, {
      path: '/deft',
      name: 'deft',
      component: deft,
      meta: {
        title: '支付失败'
      } 
    }, {
      path: '/advice/:id',
      name: 'advice',
      component: advice,
      meta: {
        title: '咨询详情'
      } 
    },{
      path: '/phone',
      name: 'phone',
      component: phone,
      meta: {
        title: '绑定手机号'
      }
    },{
      path: '/invoice',
      name: 'invoice',
      component: invoice,
      meta: {
        title: '发票申请'
      }
    },{
      path: '/personal',
      name: 'personal',
      component: personal,
      meta: {
        title: '个人开票'
      }
    },{
      path: '/detail',
      name: 'detail',
      component: detail,
      meta: {
        title: '发票详情'
      }
    },{
      path: '/problem',
      name: 'problem',
      component: problem,
      meta: {
        title: '常见问题'
      }
    }
    ]  
})



// WEBPACK FOOTER //
// ./src/router/index.js